import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "../src/style/css/globals.css";
import reportWebVitals from './reportWebVitals';
import { IconContext } from "react-icons";
import App from './App';

// REDUX
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <IconContext.Provider value={{ className: "global-class-name" }}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </IconContext.Provider>
  </Provider>
);

reportWebVitals();
